import { Box, Button, Inline, Text } from "@origin-digital/ods-core";
import { IconChevronDownSmall } from "@origin-digital/ods-icons";
import {
  useUserContext,
  getAllPropertiesForUser,
} from "@origin-digital/user-context-provider";
import React, { useState } from "react";
import { PropertySheet } from "./PropertySheet";
import { trackPropertySelectorOpen } from "./analytics";

export const PropertySelector = () => {
  const { setProperty, property, user } = useUserContext();

  const [showSheet, setShowSheet] = useState<boolean>();

  const [activeProperties, inactiveProperties] = getAllPropertiesForUser(user);
  const totalPropertyAmount =
    activeProperties.length + inactiveProperties.length;

  if (activeProperties) {
    return (
      <Box display="flex" flexDirection="row">
        <Button
          aria-label="Property Selector Button"
          variant="text"
          onClick={() => {
            trackPropertySelectorOpen(totalPropertyAmount);
            setShowSheet(true);
          }}
          color="secondaryB"
          size="small"
          data-id="property-selector"
        >
          <Inline alignY="center" space="xsmall" disableWrap={true}>
            <Text
              align="left"
              variant="body-small"
              weight="medium"
              tone="neutral"
              truncate={true}
              inline={true}
            >
              {property ? property.label?.toUpperCase() : "ALL PROPERTIES"}
            </Text>
            <IconChevronDownSmall
              size="xxxsmall"
              color="neutral"
              variant="solid"
            />
          </Inline>
        </Button>
        <PropertySheet
          selectedProperty={property}
          setProperty={setProperty}
          properties={activeProperties}
          inactiveProperties={inactiveProperties}
          open={showSheet}
          setOpen={setShowSheet}
        />
      </Box>
    );
  }
  return <></>;
};
